import {
	API_GET_SECRETARY_ACTIVE,
	API_GET_SECRETARY_ACTIVE_FAIL,
	API_GET_SECRETARY_ACTIVE_SUCCESS,
	API_GET_ALL_FOLDER_HELP,
	API_GET_ALL_FOLDER_HELP_SUCCESS,
	API_GET_ALL_FOLDER_HELP_FAIL,
	API_GET_ASSIGNED_FOLDER_HELP,
	API_GET_ASSIGNED_FOLDER_HELP_SUCCESS,
	API_DONE_FOLDER_HELP_SUCCESS,
	API_GET_STATS_FOLDER_HELP,
	API_GET_STATS_FOLDER_HELP_SUCCESS,
	API_GET_STATS_DASHBOARD,
	API_GET_STATS_DASHBOARD_SUCCESS,
	API_GET_STATS_SECRETARY_HOME,
	API_GET_STATS_SECRETARY_HOME_SUCCESS,
	API_CREATE_FOLDER_HELP_FAIL,
	API_GET_ALL_SCANS_ORDO_SUCCESS,
	API_GET_CANCEL_REASONS_SUCCESS,
	API_GET_CANCEL_REASONS_FAIL,
	API_GET_ALL_SECRETARIES_SUCCESS,
	API_GET_WAITING_FOLDER_HELP,
	API_GET_WAITING_FOLDER_HELP_SUCCESS,
	API_POST_COMMENT_FOLDER_HELP_SUCCESS,
} from "../actions/folderHelp";
import { API_DELETE_SCAN_ORDO_SUCCESS } from "actions/prescription";
import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";
import { toast } from "react-toastify";
import { getVersion } from "services/folderHelp";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

const initialState = {
	connectedLoading: false,
	foldersLoading: false,
	connectedSecretariesList: [],
	list: [],
	pagination: {},
	stats: {},
	myNurseFolderHelps: [],
	statusWaitingFolderHelps: {},
	meanTimeInfo: {},
	tvSecretaryisActivated: false,
	otherFoldersOpened: [],
	scanOrdos: [],
	cancelReasons: [],
	secretaries: [],
	queuedFolderHelps: 0,
	countMyFolders: 0,
};

const toNumber = (value) => {
	if (value === null || value === undefined) return value;
	const num = typeof value === 'string' ? parseFloat(value) : Number(value);
	return isNaN(num) ? value : num;
};

const adaptFolderHelpResponse = (folderHelp, currentClient) => {
	try {
		if (!folderHelp || currentClient !== V2_CLIENT) {
			return folderHelp;
		}

		const adapted = { ...folderHelp };

		if (adapted.folderId !== undefined && adapted.folderId !== null && adapted.folder_id === undefined) {
			adapted.folder_id = toNumber(adapted.folderId);
		}
		if (adapted.centerId !== undefined && adapted.centerId !== null && adapted.center_id === undefined) {
			adapted.center_id = toNumber(adapted.centerId);
		}
		if (adapted.secretaryId !== undefined && adapted.secretaryId !== null && adapted.secretary_id === undefined) {
			adapted.secretary_id = toNumber(adapted.secretaryId);
		}
		if (adapted.cancelReasonId !== undefined && adapted.cancelReasonId !== null && adapted.cancel_reason_id === undefined) {
			adapted.cancel_reason_id = toNumber(adapted.cancelReasonId);
		}

		const fieldMap = {
			createdAt: 'created_at',
			updatedAt: 'updated_at',
			isActive: 'is_active',
			isTvSec: 'is_tv_sec',
			isDeposit: 'is_deposit',
			supportedCount: 'supported_count',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (!adapted.comments) {
			adapted.comments = [];
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptFolderHelpResponse:', error);
		return folderHelp;
	}
};

export const adaptFolderHelpPayloadResponse = (action, actionType, currentClient) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map(item => adaptFolderHelpResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				if (data.folderHelps && Array.isArray(data.folderHelps)) {
					const adaptedFolderHelps = data.folderHelps.map(item => adaptFolderHelpResponse(item, currentClient));
					return {
						...payload,
						data: {
							...data,
							folderHelps: adaptedFolderHelps,
						},
					};
				} else if (data.results && Array.isArray(data.results)) {
					const adaptedResults = data.results.map(item => adaptFolderHelpResponse(item, currentClient));
					return {
						...payload,
						data: {
							...data,
							results: adaptedResults,
						},
					};
				} else {
					const adaptedData = adaptFolderHelpResponse(data, currentClient);
					return {
						...payload,
						data: adaptedData,
					};
				}
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptFolderHelpPayloadResponse:', error);
		return action.payload || {};
	}
};

const folderHelp = createReducer(initialState, {
	/** CONNECTED USERS **/
	[API_GET_SECRETARY_ACTIVE]: (state, action) => {
		state.connectedLoading = true;
	},
	[API_GET_SECRETARY_ACTIVE_FAIL]: (state, action) => {
		errorHandler("Secrétaires disponibles", ErrorAction.READ, action.error);
		state.connectedLoading = false;
	},
	[API_GET_SECRETARY_ACTIVE_SUCCESS]: (state, action) => {
		state.connectedLoading = false;
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_SECRETARY_ACTIVE).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_SECRETARY_ACTIVE, client);
		state.connectedSecretariesList = adaptedPayload.data || [];
	},

	/** FOLDERS **/
	[API_GET_ALL_FOLDER_HELP]: (state, action) => {
		state.foldersLoading = true;
	},
	[API_GET_ALL_FOLDER_HELP_FAIL]: (state, action) => {
		errorHandler("Dossiers en attente d'aide", ErrorAction.READ, action.error);
		state.foldersLoading = false;
	},
	[API_GET_ALL_FOLDER_HELP_SUCCESS]: (state, action) => {
		state.foldersLoading = false;
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_ALL_FOLDER_HELP).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_ALL_FOLDER_HELP, client);
		state.list = adaptedPayload.data?.results || [];
		state.pagination = {
			page: adaptedPayload.data?.page || action.payload.data?.page || 1,
			numberOfPages: adaptedPayload.data?.numberOfPages || adaptedPayload.data?.number_of_pages || action.payload.data?.numberOfPages || 1,
			totalCount: adaptedPayload.data?.totalCount || adaptedPayload.data?.total_count || action.payload.data?.totalCount || 0,
		};
	},

	[API_GET_ASSIGNED_FOLDER_HELP_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_ASSIGNED_FOLDER_HELP).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_ASSIGNED_FOLDER_HELP, client);
		
		if (adaptedPayload.data && adaptedPayload.data.folderHelps && adaptedPayload.data.folderHelps.length > 0) {
			if (
				adaptedPayload.data.folderHelps.filter((f) => f.status === "REASSIGNED").length >
				state.myNurseFolderHelps.filter((f) => f.status === "REASSIGNED").length
			)
				toast.warn("Patient à prélever ");
			else if (
				adaptedPayload.data.folderHelps.length !== state.myNurseFolderHelps.length ||
				(adaptedPayload.data.folderHelps.length === 1 &&
					state.myNurseFolderHelps.length === 1 &&
					adaptedPayload.data.folderHelps[0].id !== state.myNurseFolderHelps[0].id)
			)
				toast.warn("Télésecrétariat : mise à jour");
		}
		if (adaptedPayload.data) state.myNurseFolderHelps = adaptedPayload.data.folderHelps || [];
		if (adaptedPayload.data?.status) state.statusWaitingFolderHelps = adaptedPayload.data.status;
		state.tvSecretaryisActivated = adaptedPayload.data?.isActive || adaptedPayload.data?.is_active || false;
		state.otherFoldersOpened = adaptedPayload.data?.openFolders || adaptedPayload.data?.open_folders || [];
		state.countMyFolders = adaptedPayload.data?.supportedCount || adaptedPayload.data?.supported_count || 0;
	},

	[API_DONE_FOLDER_HELP_SUCCESS]: (state, action) => {},
	[API_CREATE_FOLDER_HELP_FAIL]: (state, action) => {
		errorHandler("Demande de télésecrétariat", ErrorAction.READ, action.error);
	},

	[API_GET_STATS_FOLDER_HELP_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_STATS_FOLDER_HELP).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_STATS_FOLDER_HELP, client);
		state.stats = adaptedPayload.data || action.payload.data;
	},
	[API_GET_STATS_DASHBOARD_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_STATS_DASHBOARD).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_STATS_DASHBOARD, client);
		state.stats = adaptedPayload.data || action.payload.data;
	},
	[API_GET_STATS_SECRETARY_HOME_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_STATS_SECRETARY_HOME).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_STATS_SECRETARY_HOME, client);
		state.stats = adaptedPayload.data || action.payload.data;
	},
	[API_GET_ALL_SCANS_ORDO_SUCCESS]: (state, action) => {
		state.scanOrdos = action.payload.data?.scans || [];
	},
	[API_DELETE_SCAN_ORDO_SUCCESS]: (state, action) => {
		if (state.scanOrdos && state.scanOrdos.length > 0) {
			const url = action.meta.previousAction.payload.request.url;
			state.scanOrdos = state.scanOrdos.filter((s) => s.id !== parseInt(url.substring(url.lastIndexOf("/") + 1)));
		}
	},
	[API_GET_CANCEL_REASONS_SUCCESS]: (state, action) => {
		state.cancelReasons = action.payload.data || [];
	},

	[API_GET_CANCEL_REASONS_FAIL]: (state, action) => {
		state.cancelReasons = [];
	},
	[API_GET_ALL_SECRETARIES_SUCCESS]: (state, action) => {
		state.secretaries = action.payload.data;
	},
	[API_GET_WAITING_FOLDER_HELP_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_WAITING_FOLDER_HELP).currentClient;
		const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_WAITING_FOLDER_HELP, client);
		state.queuedFolderHelps = toNumber(adaptedPayload.data?.queuedLength || adaptedPayload.data?.queued_length || action.payload.data?.queuedLength || 0);
	},
});

export default folderHelp;
